import axios from '@/axiosInterceptor';
import { defaultAlertFilters, defaultAlertSort } from '@/utils/alertFilters';
import { defaultLoadFilters, defaultLoadSort } from '@/utils/loadFilters';

const state = () => ({
  vehicles: [],
  has_vehicles_loaded: false,
  has_near_by_vehicles_loaded: false,
  near_by_vehicles: [],
  has_assigned_vehicle_loaded: false,
  assigned_vehicle: {},
  has_debug_vehicles_loaded: false,
  debug_vehicles: [],
  load: {},
  load_logs: [],
  has_load_logs_loaded: false,
  alert_vehicles: [],
  has_alert_vehicles_loaded: false,
  manually_added_vehicles: [],
  has_manually_added_vehicles_loaded: false,
  stop_load_logs: [],
  has_stop_load_logs_loaded: false,
  load_loading: false,
  load_route_loading: false,
  load_route: {},
  destination_route_loading: false,
  destination_route: {},
  load_route_distance_loading: false,
  load_route_distance: {},
  truck_routes: {},
  truck_route_loading: false,
  truck_route_Ids: [],
  routeIdsToDelete: [],
  event_show: null,
  movements: [],
  movements_pagination: {
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
  },
  movements_count: 0,
  movements_show_count: 0,
  open_loads_loading: false,
  open_loads_controller: null,
  open_loads: [],
  open_loads_pagination: {
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
  },
  open_loads_query: {
    view: 'all',
    tab: 'active',
    filters: defaultLoadFilters.active,
    sort: defaultLoadSort.active,
    page: 1,
  },
  no_eld_loads_loading: false,
  no_eld_loads_controller: null,
  no_eld_loads: [],
  no_eld_loads_pagination: {
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
  },
  no_eld_loads_query: {
    view: 'exceptions',
    tab: 'no-eld',
    filters: defaultLoadFilters['no-eld'],
    sort: defaultLoadSort['no-eld'],
    page: 1,
  },
  no_arrival_loads_loading: false,
  no_arrival_loads_controller: null,
  no_arrival_loads: [],
  no_arrival_loads_pagination: {
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
  },
  no_arrival_loads_query: {
    view: 'exceptions',
    tab: 'no-arrival',
    filters: defaultLoadFilters['no-arrival'],
    sort: defaultLoadSort['no-arrival'],
    page: 1,
  },
  no_departure_loads_loading: false,
  no_departure_loads_controller: null,
  no_departure_loads: [],
  no_departure_loads_pagination: {
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
  },
  no_departure_loads_query: {
    view: 'exceptions',
    tab: 'no-departure',
    filters: defaultLoadFilters['no-departure'],
    sort: defaultLoadSort['no-departure'],
    page: 1,
  },
  no_pickup_loads_loading: false,
  no_pickup_loads_controller: null,
  no_pickup_loads: [],
  no_pickup_loads_pagination: {
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
  },
  no_pickup_loads_query: {
    view: 'exceptions',
    tab: 'no-pickup',
    filters: defaultLoadFilters['no-pickup'],
    sort: defaultLoadSort['no-pickup'],
    page: 1,
  },
  no_delivery_loads_loading: false,
  no_delivery_loads_controller: null,
  no_delivery_loads: [],
  no_delivery_loads_pagination: {
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
  },
  no_delivery_loads_query: {
    view: 'exceptions',
    tab: 'no-delivery',
    filters: defaultLoadFilters['no-delivery'],
    sort: defaultLoadSort['no-delivery'],
    page: 1,
  },
  assigned_vehicle_loads_loading: false,
  assigned_vehicle_loads_controller: null,
  assigned_vehicle_loads: [],
  assigned_vehicle_loads_pagination: {
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
  },
  no_assigned_vehicle_loads_loading: false,
  no_assigned_vehicle_loads_controller: null,
  no_assigned_vehicle_loads: [],
  no_assigned_vehicle_loads_pagination: {
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
  },
  no_assigned_vehicle_loads_query: {
    view: 'exceptions',
    tab: 'no-assigned-vehicle',
    filters: defaultLoadFilters['no-assigned-vehicle'],
    sort: defaultLoadSort['no-assigned-vehicle'],
    page: 1,
  },
  pending_tracking_loads_loading: false,
  pending_tracking_loads_controller: null,
  pending_tracking_loads: [],
  pending_tracking_loads_pagination: {
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
  },
  pending_tracking_loads_query: {
    view: 'exceptions',
    tab: 'pending-tracking',
    filters: defaultLoadFilters['pending-tracking'],
    sort: defaultLoadSort['pending-tracking'],
    page: 1,
  },
  not_tracking_loads_loading: false,
  not_tracking_loads_controller: null,
  not_tracking_loads: [],
  not_tracking_loads_pagination: {
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
  },
  not_tracking_loads_query: {
    view: 'exceptions',
    tab: 'not-tracking',
    filters: defaultLoadFilters['not-tracking'],
    sort: defaultLoadSort['not-tracking'],
    page: 1,
  },
  closed_loads_loading: false,
  closed_loads_controller: null,
  closed_loads: [],
  closed_loads_pagination: {
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
  },
  closed_loads_query: {
    view: 'all',
    tab: 'closed',
    filters: defaultLoadFilters.closed,
    sort: defaultLoadSort.closed,
    page: 1,
  },
  result_loads_loading: false,
  result_loads_controller: null,
  result_loads: [],
  result_loads_pagination: {
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
  },
  open_alerts_loading: false,
  open_alerts_controller: null,
  open_alerts: [],
  open_alerts_pagination: {
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
  },
  open_alerts_query: {
    view: 'all',
    tab: 'open',
    filters: defaultAlertFilters.open,
    sort: defaultAlertSort.open,
    page: 1,
  },
  closed_alerts_loading: false,
  closed_movement_tickets_controller: null,
  closed_alerts: [],
  closed_alerts_pagination: {
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
  },
  closed_alerts_query: {
    view: 'all',
    tab: 'closed',
    filters: defaultAlertFilters.closed,
    sort: defaultAlertSort.closed,
    page: 1,
  },
  pending_alerts_loading: false,
  pending_alerts_controller: null,
  pending_alerts: [],
  pending_alerts_pagination: {
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
  },
  pending_alerts_query: {
    view: 'pending',
    tab: 'pending',
    filters: defaultAlertFilters.pending,
    sort: defaultAlertSort.pending,
    page: 1,
  },
  recommended_alerts_loading: false,
  recommended_alerts_controller: null,
  recommended_alerts: [],
  recommended_alerts_pagination: {
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
  },
  recommended_alerts_query: {
    view: 'pending',
    tab: 'recommended',
    filters: defaultAlertFilters.recommended,
    sort: defaultAlertSort.recommended,
    page: 1,
  },
  open_rate_con_tickets: [],
  open_rate_con_tickets_pagination: {
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
  },
  load_lock_events_closed: [],
  load_lock_events_closed_pagination: {
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
  },
  rate_confirmations: [],
  carrier_eld_touches: [],
  truck_trace_data: [],
  has_truck_trace_data_loaded: false,
  carrier_eld_vehicles: [],
  has_carrier_eld_touches_loaded: false,
  has_called_load_index: false,
  is_map_set_up: false,
  is_map_set_up_completed: false,
  selected_flag_options: null,
  selected_load_options: null,
  eld_days_to_show: 3,
  movements_loading: false,
  default_start_days_before: 2,
  default_end_days_after: 5,
  movement_results_per_page: 20,
  alert_table_version: 1,
  alert_table_max: 2,
  user_ticket_role: null,
  load_lock_assignees: [],
  results_per_page: 50,
  use_monitor_routes: false,
  trace_data_load_id: null,
  recent_by_cv_load_id: null,
  show_route: null,
  alert_count: 0,
  shipper_link: null,
  is_shipper_link_loading: false,
  alertTypes: [],
  hasAlertTypesLoaded: false,
  isAlertTypesLoading: false,
  subscriptionStatus: 'load_lock',
});

const getters = {
  getLoadsTabQuery: (state) => (tab) => {
    switch (tab) {
      case 'no-eld':
        return state.no_eld_loads_query;
      case 'no-arrival':
        return state.no_arrival_loads_query;
      case 'no-departure':
        return state.no_departure_loads_query;
      case 'no-pickup':
        return state.no_pickup_loads_query;
      case 'no-delivery':
        return state.no_delivery_loads_query;
      case 'no-assigned-vehicle':
        return state.no_assigned_vehicle_loads_query;
      case 'pending-tracking':
        return state.pending_tracking_loads_query;
      case 'not-tracking':
        return state.not_tracking_loads_query;
      case 'closed':
        return state.closed_loads_query;
      default:
        return state.open_loads_query;
    }
  },
  getAlertsTabQuery: (state) => (tab) => {
    switch (tab) {
      case 'closed':
        return state.closed_alerts_query;
      case 'pending':
        return state.pending_alerts_query;
      case 'recommended':
        return state.recommended_alerts_query;
      default:
        return state.open_alerts_query;
    }
  },
};

// helpers

const getAlertScope = (type) => {
  switch (type) {
    case 'open':
      return {
        controller: 'open_alerts_controller',
        setController: 'setOpenMovementTicketsController',
        data: 'setOpenMovementTickets',
        loading: 'setOpenMovementTicketsLoading',
        query: '&q[status_not_in][]=closed',
        pagination: 'setOpenMovementTicketsPagination',
      };
    case 'pending':
      return {
        controller: 'pending_alerts_controller',
        setController: 'setPendingAlertsController',
        data: 'setPendingAlerts',
        loading: 'setPendingAlertsLoading',
        query: '&q[status_in][]=pending',
        pagination: 'setPendingAlertsPagination',
      };
    case 'recommended':
      return {
        controller: 'recommended_alerts_controller',
        setController: 'setRecommendedAlertsController',
        data: 'setRecommendedAlerts',
        loading: 'setRecommendedAlertsLoading',
        query: '&q[status_in][]=pending',
        pagination: 'setRecommendedAlertsPagination',
      };
    default:
      return {
        controller: 'closed_movement_tickets_controller',
        setController: 'setClosedMovementTicketsController',
        data: 'setClosedMovementTickets',
        loading: 'setClosedMovementTicketsLoading',
        query: '&q[closed]=1',
        pagination: 'setClosedMovementTicketsPagination',
      };
  }
};

const getSaveAlertQuerySetter = (type) => {
  switch (type) {
    case 'closed':
      return 'setClosedMovementTicketsQuery';
    case 'pending':
      return 'setPendingAlertsQuery';
    case 'recommended':
      return 'setRecommendedAlertsQuery';
    default:
      return 'setOpenMovementTicketsQuery';
  }
};

const getSaveLoadQuerySetter = (type) => {
  switch (type) {
    case 'no-eld':
      return 'setNoEldLoadsQuery';
    case 'no-arrival':
      return 'setNoArrivalLoadsQuery';
    case 'no-departure':
      return 'setNoDepartureLoadsQuery';
    case 'no-pickup':
      return 'setNoPickupLoadsQuery';
    case 'no-delivery':
      return 'setNoDeliveryLoadsQuery';
    case 'not-tracking':
      return 'setNotTrackingLoadsQuery';
    case 'no-assigned-vehicle':
      return 'setNoAssignedVehicleLoadsQuery';
    case 'closed':
      return 'setClosedLoadsQuery';
    default:
      return 'setOpenLoadsQuery';
  }
};

const getLoadsScope = (type) => {
  switch (type) {
    case 'no-eld':
      return {
        controller: 'no_eld_loads_controller',
        setController: 'setNoEldLoadsController',
        pagination: 'setNoEldLoadsPagination',
        data: 'setNoEldLoads',
        loading: 'setNoEldLoadsLoading',
        query:
          '&q[billable_miles_gteq]=150&q[tracking_status_not_start]=not_eligible&q[highway_connect_eld]=1',
      };
    case 'no-arrival':
      return {
        controller: 'no_arrival_loads_controller',
        setController: 'setNoArrivalLoadsController',
        pagination: 'setNoArrivalLoadsPagination',
        data: 'setNoArrivalLoads',
        loading: 'setNoArrivalLoadsLoading',
        // endpoint: '/index_failed_to_arrive',
        query:
          '&q[billable_miles_gteq]=150&q[tracking_status_not_start]=not_eligible&q[assigned]=1&q[with_failed_to_arrive]=1',
      };
    case 'no-departure':
      return {
        controller: 'no_departure_loads_controller',
        setController: 'setNoDepartureLoadsController',
        pagination: 'setNoDepartureLoadsPagination',
        data: 'setNoDepartureLoads',
        loading: 'setNoDepartureLoadsLoading',
        // endpoint: '/index_failed_to_depart',
        query:
          '&q[billable_miles_gteq]=150&q[tracking_status_not_start]=not_eligible&q[assigned]=1&q[with_failed_to_depart]=1',
      };
    case 'no-pickup':
      return {
        controller: 'no_pickup_loads_controller',
        setController: 'setNoPickupLoadsController',
        pagination: 'setNoPickupLoadsPagination',
        data: 'setNoPickupLoads',
        loading: 'setNoPickupLoadsLoading',
        query:
          '&q[billable_miles_gteq]=150&[tracking_status_not_start]=not_eligible&q[assigned]=1&q[highway_failed_to_pickup]=1',
      };
    case 'no-delivery':
      return {
        controller: 'no_delivery_loads_controller',
        setController: 'setNoDeliveryLoadsController',
        pagination: 'setNoDeliveryLoadsPagination',
        data: 'setNoDeliveryLoads',
        loading: 'setNoDeliveryLoadsLoading',

        query:
          '&q[billable_miles_gteq]=150&[tracking_status_not_start]=not_eligible&q[highway_failed_to_deliver]=1',
      };
    case 'not-tracking':
      return {
        controller: 'not_tracking_loads_controller',
        setController: 'setNotTrackingLoadsController',
        pagination: 'setNotTrackingLoadsPagination',
        data: 'setNotTrackingLoads',
        loading: 'setNotTrackingLoadsLoading',
        query:
          '&q[billable_miles_gteq]=150&q[tracking_status_not_start]=not_eligible&q[assigned]=1',
      };
    case 'no-assigned-vehicle':
      return {
        controller: 'no_assigned_vehicle_loads_controller',
        setController: 'setNoAssignedVehicleLoadsController',
        pagination: 'setNoAssignedVehicleLoadsPagination',
        data: 'setNoAssignedVehicleLoads',
        loading: 'setNoAssignedVehicleLoadsLoading',
        query:
          '&q[billable_miles_gteq]=150&q[tracking_status_not_start]=not_eligible&q[highway_assign_vehicle]=1',
      };
    case 'pending-tracking':
      return {
        controller: 'pending_tracking_loads_controller',
        setController: 'setPendingTrackingLoadsController',
        pagination: 'setPendingTrackingLoadsPagination',
        data: 'setPendingTrackingLoads',
        loading: 'setPendingTrackingLoadsLoading',
        query:
          '&q[billable_miles_gteq]=150&q[tracking_status_not_start]=not_eligible&q[assigned]=1',
      };
    case 'closed':
      return {
        controller: 'closed_loads_controller',
        setController: 'setClosedLoadsController',
        pagination: 'setClosedLoadsPagination',
        data: 'setClosedLoads',
        loading: 'setClosedLoadsLoading',
        query: '&q[fe_closed]=1',
      };
    case 'result':
      return {
        controller: 'result_loads_controller',
        setController: 'setResultLoadsController',
        pagination: 'setResultLoadsPagination',
        data: 'setResultLoads',
        loading: 'setResultLoadsLoading',
        query: '',
      };
    default:
      return {
        controller: 'open_loads_controller',
        setController: 'setOpenLoadsController',
        pagination: 'setOpenLoadsPagination',
        data: 'setOpenLoads',
        loading: 'setOpenLoadsLoading',
        query: '&q[fe_open]=1',
      };
  }
};

const getLoadLogsScope = (type) => {
  switch (type) {
    case 'physical_location_out_of_range_from_origin':
      return {
        data: 'setAlertVehicles',
        loaded: 'setHasAlertVehiclesLoaded',
        query: '?q[is_type_eq]=physical_location_out_of_range_from_origin',
      };
    case 'manually-added-vehicles':
      return {
        data: 'setManuallyAddedVehicles',
        loaded: 'setManuallyAddedVehiclesLoaded',
        query:
          '?q[is_type_in][]=manually_entered_vin_belongs_to_different_carrier&q[is_type_in][]=manually_entered_vin_not_found',
      };
    case 'load-updates':
      return {
        data: 'setLoadLogs',
        loaded: 'setHasLoadLogsLoaded',
        query: `?q[external_message_not_eq]=null&q[category_or_is_type_in][]=load_created&q[category_or_is_type_in][]=material_changes&q[category_or_is_type_in][]=carrier_assigned&q[category_or_is_type_in][]=carrier_changed&q[category_or_is_type_in][]=carrier_vehicle_tms_assigned&q[category_or_is_type_in][]=received_tms_vehicle_and_found`,
      };
    case 'tracking-updates':
      return {
        data: 'setLoadLogs',
        loaded: 'setHasLoadLogsLoaded',
        query: `?q[external_message_not_eq]=null&q[is_type_in][]=ping_successful&q[is_type_in][]=tracking_ended&q[is_type_in][]=carrier_vehicle_assigned&q[is_type_in][]=ping_successful_no_update&q[is_type_in][]=arrived_at_stop&q[is_type_in][]=departed_stop&q[is_type_in][]=inner_stop_geofence_break&q[is_type_in][]=outer_stop_geofence_break`,
      };
    case 'comments':
      return {
        data: 'setLoadLogs',
        loaded: 'setHasLoadLogsLoaded',
        query: '?q[external_message_not_eq]=null&q[is_type_in][]=comments',
      };
    case 'stop':
      return {
        data: 'setStopLoadLogs',
        loaded: 'setHasStopLoadLogsLoaded',
        query: '?q[is_type_in][]=arrived_at_stop&q[is_type_in][]=departed_stop',
      };
    default:
      return {
        data: 'setLoadLogs',
        loaded: 'setHasLoadLogsLoaded',
        query: '?q[external_message_not_eq]=null',
      };
  }
};

const getRouteScope = (type) => {
  switch (type) {
    case 'destination':
      return {
        data: 'setDestinationRoute',
        loading: 'setDestinationRouteLoading',
      };
    case 'origin':
      return {
        data: 'setOriginRoute',
        loading: 'setOriginRouteLoading',
      };
    default:
      return {
        data: 'setLoadRoute',
        loading: 'setLoadRouteLoading',
      };
  }
};

const loadsLocalStorage = {
  result: {
    storageResults: 'loadResultSearchResults',
    storagePagination: 'loadResultSearchResultsPagination',
    setResultsState: 'setResultLoads',
    setPagination: 'setResultLoadsPagination',
    setLoading: 'setResultLoadsLoading',
  },
  open: {
    storageResults: 'loadOpenSearchResults',
    storagePagination: 'loadOpenSearchResultsPagination',
    setResultsState: 'setOpenLoads',
    setPagination: 'setOpenLoadsPagination',
    setLoading: 'setOpenLoadsLoading',
  },
  'assigned-vehicle': {
    storageResults: 'loadAssignedVehiclesSearchResults',
    storagePagination: 'loadAssignedVehiclesSearchResultsPagination',
    setResultsState: 'setAssignedVehicleLoads',
    setPagination: 'setAssignedVehicleLoadsPagination',
    setLoading: 'setAssignedVehicleLoadsLoading',
  },
  'no-assigned-vehicle': {
    storageResults: 'loadNoAssignedVehiclesSearchResults',
    storagePagination: 'loadNoAssignedVehiclesSearchResultsPagination',
    setResultsState: 'setNoAssignedVehicleLoads',
    setPagination: 'setNoAssignedVehicleLoadsPagination',
    setLoading: 'setNoAssignedVehicleLoadsLoading',
  },
  closed: {
    storageResults: 'loadClosedSearchResults',
    storagePagination: 'loadClosedSearchResultsPagination',
    setResultsState: 'setClosedLoads',
    setPagination: 'setClosedLoadsPagination',
    setLoading: 'setClosedLoadsLoading',
  },
  'alerts-open': {
    storageResults: 'alertsOpenSearch',
    storagePagination: 'alertsOpenSearchPagination',
    setResultsState: 'setOpenMovementTickets',
    setPagination: 'setOpenMovementTicketsPagination',
    setLoading: 'setOpenMovementTicketsLoading',
  },
  'alerts-closed': {
    storageResults: 'alertsClosedSearch',
    storagePagination: 'alertsClosedSearchPagination',
    setResultsState: 'setClosedMovementTickets',
    setPagination: 'setClosedMovementTicketsPagination',
    setLoading: 'setClosedMovementTicketsLoading',
  },
};

// actions
const actions = {
  initializeStore({ commit }) {
    if (
      window.location.href.includes('broker/loads') ||
      window.location.href.includes('broker/alerts')
    ) {
      // eslint-disable-next-line no-unused-vars
      Object.entries(loadsLocalStorage).forEach(([_, item]) => {
        const searchResults = localStorage.getItem(item.storageResults);
        const searchPagination = localStorage.getItem(item.storagePagination);

        if (searchResults && searchResults !== 'undefined') {
          commit(item.setResultsState, JSON.parse(searchResults));
          commit(item.setPagination, JSON.parse(searchPagination));
          commit(item.setLoading, false);
        }
      });
    }
  },
  saveTabQueryObject({ commit }, { type, query, pageName = 'Loads' }) {
    const setQuery =
      pageName === 'Alerts'
        ? getSaveAlertQuerySetter(type)
        : getSaveLoadQuerySetter(type);
    commit(setQuery, query);
  },
  clearLoad({ commit }) {
    commit('setLoad', {});
    commit('setLoadLogs', []);
    commit('setHasLoadLogsLoaded', false);
    commit('setAlertVehicles', []);
    commit('setHasAlertVehiclesLoaded', false);
    commit('setLoadRoute', {});
    commit('setAssignedVehicle', {});
    commit('setHasAssignedVehicleLoaded', false);
  },
  async getLoadLogs({ commit }, { type = '', id }) {
    const { data, loaded, query } = getLoadLogsScope(type);
    try {
      commit(loaded, false);
      const res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/loads/${id}/load_logs${query}`
      );
      // for testing only
      // let res;
      // if (type === 'physical_location_out_of_range_from_origin') {
      //   res = await axios.get(`http://localhost:4000/alert_vehicles`);
      // } else if (type === 'stop') {
      //   res = await axios.get(`http://localhost:4000/stop_load_logs`);
      // } else {
      //   res = await axios.get(`http://localhost:4000/load_logs`);
      // }
      commit(loaded, true);
      if ([200, 201, 204].includes(res?.status) && res.data) {
        commit(data, res.data);
      } else {
        throw new Error('No data returned from API', { cause: res });
      }
      return res;
    } catch (e) {
      console.log('error', e);
      commit(loaded, true);
      commit(data, []);
    }
  },
  async getAlertTypes({ commit }) {
    try {
      commit('setHasAlertTypesLoaded', false);
      commit('setIsAlertTypesLoading', true);
      const res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/tickets/alert_types`
      );
      commit('setIsAlertTypesLoading', false);
      commit('setHasAlertTypesLoaded', true);
      if ([200, 201, 204].includes(res?.status) && res.data) {
        commit('setAlertTypes', res.data);
        commit('setSubscriptionStatus', res.data.subscription_status);
      } else {
        throw new Error('No data returned from API', { cause: res });
      }
      return res;
    } catch (e) {
      console.log('error', e);
      commit('setAlertTypes', []);
      commit('setIsAlertTypesLoading', false);
      commit('setHasAlertTypesLoaded', true);
    }
  },
  async manuallyUpdateLoadLogs({ commit }, { id, stop_id, type, date }) {
    // arrived_at_stop
    // departed_stop
    // delivered

    const params = {
      load_id: id,
      stop_id: stop_id,
      occurred_at: date,
      is_type: type,
    };

    try {
      commit('setHasLoadLogsLoaded', false);

      const res = await axios.post(
        `${process.env.API_MONITOR}/api/v1/load_logs`,
        params
      );
      if ([200, 201, 204].includes(res?.status) && res.data) {
        commit('setHasLoadLogsLoaded', true);
      }

      return res;
    } catch (e) {
      commit('setHasLoadLogsLoaded', true);

      if (axios.isAxiosError(e) && [403, 422].includes(e.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async patchLoad(_, options) {
    try {
      const res = await axios.patch(
        process.env.API_MONITOR + '/api/v1/loads/' + options.id,
        options.payload
      );
      // for testing vehicle assignment with json-server
      // const res = await axios.patch(
      //   `http://localhost:4000/load`,
      //   options.payload
      // );
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getRouteDistance({ commit }, payload) {
    const token = process.env.MAPBOX_TOKEN;
    const { sources = 0, type = 'load' } = payload;
    const coordinates = `${payload.stops[0]?.longitude_for_map},${payload.stops[0]?.latitude_for_map};${payload.stops[payload.stops.length - 1]?.longitude_for_map},${payload.stops[payload.stops.length - 1]?.latitude_for_map}`;
    try {
      commit('setLoadRouteDistanceLoading', true);
      const response = await axios.get(
        `https://api.mapbox.com/directions-matrix/v1/mapbox/driving/${coordinates}?sources=${sources}&annotations=distance,duration&access_token=${token}`
      );
      commit('setLoadRouteDistanceLoading', false);
      if (type === 'load') {
        commit('setLoadRouteDistance', response.data);
      }
    } catch (e) {
      commit('setLoadRouteDistanceLoading', false);
      if (axios.isAxiosError(e) && [403, 422].includes(e.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getRoute({ commit }, { type = 'load', coordinates }) {
    const token = process.env.MAPBOX_TOKEN;
    const { loading, data } = getRouteScope(type);
    try {
      commit(loading, true);
      const response = await axios.get(
        `https://api.mapbox.com/directions/v5/mapbox/driving/${coordinates}?steps=true&geometries=geojson&avoid_maneuver_radius=1000&overview=full&access_token=${token}`
      );
      let route = {};
      if (response.data.routes.length) {
        route = response.data.routes[0].geometry;
      } else {
        commit(loading, false);
        throw new Error('No data returned from API', { cause: response });
      }
      commit(data, route);
      commit(loading, false);
      return route;
    } catch (e) {
      console.log('error', e);
      commit(data, {});
      commit(loading, false);
    }
  },
  // to be used for sub-minute pings to snap to OpenStreetMap street data, not for coordinates with large distance gaps
  // async getMatchedRoute({ commit }, { geometry, loading, data }) {
  //   const token = process.env.MAPBOX_TOKEN;
  //   const coordString = geometry.coordinates
  //     .map((coord) => coord.join(','))
  //     .join(';');
  //   const radiuses = geometry.coordinates.map((coord) => '50').join(';');
  //   try {
  //     const response = await axios.get(
  //       `https://api.mapbox.com/matching/v5/mapbox/driving-traffic/${coordString}?steps=true&geometries=geojson&overview=full&annotations=distance,duration,speed,congestion,congestion_numeric,maxspeed&tidy=true&access_token=${token}`
  //     );
  //     console.log('matched route', response.data);
  //     let route = {
  //       coordinates: [],
  //       type: 'LineString',
  //     };
  //     if (response.data.matchings.length) {
  //       response.data.matchings.forEach((m) => {
  //         route.coordinates = route.coordinates.concat(
  //           m.geometry.coordinates.map((coord) => {
  //             return [coord[0], coord[1]];
  //           })
  //         );
  //       });
  //     } else {
  //       throw new Error('No data returned from matching API', {
  //         cause: response,
  //       });
  //     }
  //     commit(loading, false);
  //     console.log('SETTING matched route', route);
  //     commit(data, route);
  //     return route;
  //   } catch (e) {
  //     commit(loading, false);
  //     if (axios.isAxiosError(e) && [403, 422].includes(e.response?.status)) {
  //       return e.response;
  //     } else {
  //       throw e;
  //     }
  //   }
  // },
  async getMapboxTruckRoute({ commit }, payload) {
    const token = process.env.MAPBOX_TOKEN;
    const {
      coordinates = '',
      carrierVehicleId = '',
      section = 'origin',
    } = payload;
    try {
      commit('setTruckRouteLoading', true);
      const response = await axios.get(
        `https://api.mapbox.com/directions/v5/mapbox/driving/${coordinates}?steps=true&geometries=geojson&avoid_maneuver_radius=1000&overview=full&access_token=${token}`
      );
      commit('setTruckRouteLoading', false);
      const route = response.data.routes[0].geometry;
      commit('addTruckRoute', {
        carrierVehicleId: carrierVehicleId,
        route: route,
        section: section,
      });
      return route;
    } catch (e) {
      commit('setTruckRouteLoading', false);
      if (axios.isAxiosError(e) && [403, 422].includes(e.response?.status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getAssignedVehicle({ commit }, loadId) {
    commit('setHasAssignedVehicleLoaded', false);
    try {
      let res = await axios.get(
        process.env.API_MONITOR +
          '/api/v1/loads/' +
          loadId +
          '/carrier_vehicle_area_trace_data'
      );
      // for testing vehicle assignment with json-server
      // let res = await axios.get(
      //   `http://localhost:4000/assigned_vehicle_${loadId}`
      // );
      // for testing only
      // let res = await axios.get(`http://localhost:4000/assigned_vehicle`);
      commit('setHasAssignedVehicleLoaded', true);
      if (res.status < 400 && res?.data) {
        commit('setAssignedVehicle', res.data);
        return res;
      } else {
        throw new Error('No data returned from API', { cause: res });
      }
    } catch (error) {
      commit('setHasAssignedVehicleLoaded', true);
      commit('setAssignedVehicle', {});
      // console.log('error', error);
      return error;
    }
  },
  async getVehicles({ commit }, loadId) {
    commit('setHasVehiclesLoaded', false);
    try {
      const res = await axios.get(
        process.env.API_MONITOR +
          '/api/v1/loads/' +
          loadId +
          '/carrier_vehicles_for_vehicle_dropdown'
      );
      // for testing only
      // let res = await axios.get('http://localhost:4000/vehicles');
      if (res?.status < 400 && res?.data) {
        commit('setHasVehiclesLoaded', true);
        commit('setVehicles', res.data);
        return res;
      }
      if (res) {
        throw new Error('No data returned from API', { cause: res });
      }
    } catch (error) {
      commit('setHasVehiclesLoaded', true);
      commit('setVehicles', {});
      console.error('error', error);
    }
  },
  async getNearbyVehicles({ commit }, loadId) {
    commit('setHasNearByVehiclesLoaded', false);
    commit('setNearByVehicles', []);
    try {
      let res = await axios.get(
        process.env.API_MONITOR +
          '/api/v1/loads/' +
          loadId +
          '/recent_carrier_vehicle_areas_by_carrier_vehicle'
      );
      // for testing only
      // let res = await axios.get('http://localhost:4000/nearby_vehicles');
      commit('setHasNearByVehiclesLoaded', true);
      if (res.status < 400 && res?.data) {
        commit('setNearByVehicles', res.data);
        return res;
      } else {
        throw new Error('No data returned from API', { cause: res });
      }
    } catch (error) {
      commit('setHasNearByVehiclesLoaded', true);
      commit('setNearByVehicles', []);
      console.log('error', error);
      return error;
    }
  },
  async getDebugVehicles({ commit }, loadId) {
    commit('setHasDebugVehiclesLoaded', false);
    commit('setDebugVehicles', []);
    try {
      let res = await axios.get(
        process.env.API_MONITOR +
          '/api/v1/loads/' +
          loadId +
          '/carrier_vehicle_areas_for_debugging'
      );
      // for testing only
      // let res = await axios.get(`http://localhost:4000/debug_vehicles`);
      commit('setHasDebugVehiclesLoaded', true);
      if (res.status < 400 && res?.data) {
        commit('setDebugVehicles', res.data);
        return res;
      } else {
        throw new Error('No data returned from API', { cause: res });
      }
    } catch (error) {
      commit('setHasDebugVehiclesLoaded', true);
      commit('setDebugVehicles', []);
      // console.log('error', error);
      return error;
    }
  },
  async getCarrierTrucks({ commit }, loadId) {
    commit('setHasTruckTraceDataLoaded', false);
    try {
      let res = await axios.get(
        process.env.API_MONITOR +
          '/api/v1/loads/' +
          loadId +
          '/vehicle_distances_to_pickup'
      );
      commit('setHasTruckTraceDataLoaded', true);
      if (res.status < 400 && res?.data) {
        commit('setTruckTraceData', res.data);
        return res;
      } else {
        throw new Error('No data returned from API', { cause: res });
      }
    } catch (e) {
      commit('setTruckTraceData', []);
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getTruckLocations({ commit }, payload) {
    commit('setHasCarrierELDTouchesLoaded', false);
    try {
      let res = await axios.get(
        process.env.API_MONITOR +
          `/api/v1/carrier_vehicle_areas/by_carrier_vehicle?${payload.query}limit=${payload.limit || 5}`
      );
      commit('setHasCarrierELDTouchesLoaded', true);
      if (res?.data) {
        if (payload?.truck_data?.length > 0) {
          let orderedData = [];
          payload.truck_data.forEach((cv) => {
            let found = res.data.find(
              (data) => data.carrier_vehicle_id === cv.cv_id
            );
            if (found) {
              orderedData.push({ ...found, ...cv });
            }
          });
          commit('setCarrierELDTouches', orderedData);
        } else {
          commit('setCarrierELDTouches', res.data);
        }
      } else {
        throw new Error('No data returned from API', { cause: res });
      }
      return res;
    } catch (e) {
      commit('setCarrierELDTouches', []);
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getLoads(
    { commit, state },
    options = {
      page: 1,
      type: 'open',
      filters: '',
      search: '',
      allQuery: '',
      sort: '',
    }
  ) {
    const {
      page,
      type,
      filters = '',
      search = '',
      allQuery = '',
      sort = '',
    } = options;
    // let company_param = '';
    // if (rootState.users.currentUser?.company?.id) {
    //   company_param = `&q[company_id_eq]=${rootState.users.currentUser?.company?.id}`;
    // }
    const {
      query = '',
      data,
      pagination,
      loading,
      endpoint = '',
      controller,
      setController,
    } = getLoadsScope(type);

    const querySort = sort || 'id+desc';

    // prevent multiple requests for the same tab
    const previousController = state[controller];
    if (previousController) {
      previousController.abort();
      commit(setController, null);
    }

    try {
      commit(loading, true);
      const controller = new AbortController();
      commit(setController, controller);
      const url = `${process.env.API_MONITOR}/api/v1/loads${endpoint}?q[s]=${querySort}&page=${page}&per_page=50${query}${filters}${search}${allQuery}`;
      const response = await axios.get(url, {
        signal: controller.signal,
      });
      // for testing only
      // const response = await axios.get('http://localhost:4000/loads');
      // if (response) {
      //   response.headers = {
      //     currentpage: page,
      //     totalpages: page,
      //     totalitems: response.data?.length || 0,
      //   };
      // }
      if (response?.data && response?.headers?.currentpage) {
        commit(setController, null);
        commit(loading, false);
        commit(data, response.data);
        commit(pagination, response.headers);
        return;
      }
      if (response) {
        throw new Error('No data returned from API', { cause: response });
      }
    } catch (error) {
      console.error(error);
      commit(setController, null);
      commit(loading, false);
      commit(data, []);
      commit(pagination, {
        currentpage: 1,
        totalpages: 1,
        totalitems: 0,
      });
    }
  },
  async getAlerts(
    { commit, state, rootState },
    options = {
      page: 1,
      type: 'open',
      filters: '',
      search: '',
      allQuery: '',
      sort: '',
    }
  ) {
    const {
      page,
      type,
      filters = '',
      search = '',
      allQuery = '',
      sort = '',
    } = options;
    let company_param = '';
    // if (rootState.users.currentUser?.company?.id) {
    //   company_param = `&q[company_id_eq]=${rootState.users.currentUser?.company?.id}`;
    // }
    // set sort options based on feature flags
    const isTicketPrioritySortEnabled =
      rootState.users.featureFlags?.fe_ticket_priority_sort?.enabled;
    const isTicketOpenSearchEnabled =
      rootState.users.featureFlags?.ticket_search_opensearch?.enabled;
    const selectedSort = sort || 'id+desc';
    const primarySort =
      isTicketOpenSearchEnabled && isTicketPrioritySortEnabled
        ? '&q[s]=status_priority+asc'
        : isTicketPrioritySortEnabled
          ? `&q[custom_ticket_sort]=status_priority+asc+${selectedSort}`
          : `&q[s]=${selectedSort}`;
    const secondarySort =
      isTicketOpenSearchEnabled && isTicketPrioritySortEnabled
        ? `&q[secondary_sort]=${selectedSort}`
        : '';
    const assignee =
      type === 'recommended'
        ? `&q[assignee_id_eq]=${rootState.users?.currentUser?.id}`
        : '';
    const { data, pagination, loading, query, controller, setController } =
      getAlertScope(type);

    // prevent multiple requests for the same tab
    const previousController = state[controller];
    if (previousController) {
      previousController.abort();
      commit(setController, null);
    }

    try {
      commit(loading, true);
      const controller = new AbortController();
      commit(setController, controller);
      const url = `${process.env.API_MONITOR}/api/v1/tickets?${primarySort}${secondarySort}&page=${page}&per_page=50${assignee}${query}&load_id_not_null=1${company_param}${filters}${search}${allQuery}`;
      const response = await axios.get(url, {
        signal: controller.signal,
      });
      if (response?.data && response?.headers?.currentpage) {
        commit(setController, null);
        commit(loading, false);
        commit(data, response.data);
        commit(pagination, response.headers);
        return;
      }
      if (response) {
        throw new Error('No data returned from API', { cause: response });
      }
    } catch (error) {
      console.error(error);
      commit(setController, null);
      commit(loading, false);
      commit(data, []);
      commit(pagination, { currentpage: 1, totalpages: 1, totalitems: 0 });
    }
  },
  /**
   * @param {Function} context.commit - Vuex commit method.
   * @param {string[]} statuses - Array of statuses to filter the ticket count.
   * @returns {Promise<Object>} Response object containing `{ count: number }` or error response.
   */
  async getAlertCount({ commit }, statuses) {
    try {
      const res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/tickets/count`,
        {
          params: {
            'q[status_in]': statuses,
            load_id_not_null: 1,
          },
        }
      );
      commit('setAlertCount', res.data);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getLoad({ commit }, id) {
    try {
      commit('setLoadLoading', true);
      let res = await axios.get(
        process.env.API_MONITOR + '/api/v1/loads/' + id
      );
      // for testing only
      // let res = await axios.get('http://localhost:4000/load');
      commit('setLoadLoading', false);
      if (res?.data) {
        commit('setLoad', res.data);
        if (
          res.data.stops &&
          res.data.stops.length &&
          (!res.data.stops[0].latitude || !res.data.stops[0].longitude)
        ) {
          // commit('setUseMonitorRoutes', true);
        }
        commit('incrementMovementsShowCount');
        if (res.data?.carrier_vehicle_id) {
          commit('setTraceDataLoadId', res.data?.id);
          // dispatch('getCarrierVehicleAreaTraceData', res.data?.id);
        } else {
          commit('setRecentByCVLoadId', res.data?.id);
          // dispatch(
          //   'getRecentCarrierVehicleAreasByCarrierVehicle',
          //   res.data?.id
          // );
        }
      }
      commit('setHasCalledLoadIndex', true);
      return res;
    } catch (e) {
      commit('setLoadLoading', false);
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getUserTicketRole({ rootState, commit }) {
    let role = 'blocked';
    // console.dir(rootState.users.currentUser?.scopes);
    if (
      rootState.users.currentUser?.scopes?.includes(
        'tickets_load_lock_manager'
      ) ||
      rootState.users.currentUser?.scopes?.includes('compliance')
    ) {
      role = 'manager';
    } else {
      role = 'staff';
    }
    // If we end up switching to a role-based system, we can use the following code
    // else if (
    //   rootState.users.currentUser?.scopes?.includes("tickets_load_lock_staff")
    // ) {
    //   role = "staff";
    // } else if (
    //   rootState.users.currentUser?.scopes?.includes("tickets_load_lock_viewer")
    // ) {
    //   role = "viewer";
    // }
    commit('setUserTicketRole', role);
  },
  async updateAlert({ commit }, payload) {
    try {
      let res = await axios.patch(
        process.env.API_MONITOR + '/api/v1/tickets/' + payload?.ticket?.id,
        payload
      );
      if ([200, 201, 204].includes(res?.status)) {
        commit('updateMovementTicket', res.data);
      }
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getLoadLockAssignees({ rootState, state, commit }) {
    // if (
    //   state.user_ticket_role != "manager" &&
    //   state.user_ticket_role != "staff"
    // ) {
    //   return {
    //     status: 403,
    //     data: {
    //       message:
    //         "You do not have permission to access load lock team details",
    //     },
    //   };
    // }
    let q =
      'q[user_scopes_scope_matches_any][]=compliance&q[user_scopes_scope_matches_any][]=tickets_load_lock_manager';
    if (state.user_ticket_role === 'manager') {
      // Will need to update to tickets_load_lock_staff (and managers/compliance) only if we want to be able to assign to only those users
      q = '';
    }

    try {
      let res = await axios.get(process.env.API_MONITOR + '/api/v1/users?' + q);
      commit('setLoadLockAssignees', {
        data: res?.data,
        user: rootState.users.currentUser,
      });
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getShipperLink({ commit }, id) {
    try {
      commit('setIsShipperLinkLoading', true);
      const res = await axios.post(
        `${process.env.API_MONITOR}/api/v1/loads/${id}/generate_shipper_link`
      );
      commit('setIsShipperLinkLoading', false);
      if (res?.data?.token) {
        commit('setShipperLink', res.data.token);
        return res;
      }
      throw new Error('No token returned from API', { cause: res });
    } catch (e) {
      commit('setIsShipperLinkLoading', false);
      commit('setShipperLink', null);
      return e;
    }
  },
};

// mutations
const mutations = {
  setSubscriptionStatus(state, status) {
    state.subscriptionStatus = status;
  },
  setHasAlertTypesLoaded(state, data) {
    state.hasAlertTypesLoaded = data;
  },
  setIsAlertTypesLoading(state, bool) {
    state.isAlertTypesLoading = bool;
  },
  setAlertTypes(state, data) {
    state.alertTypes = data;
  },
  setShipperLink(state, link) {
    state.shipper_link = link;
  },
  setIsShipperLinkLoading(state, bool) {
    state.is_shipper_link_loading = bool;
  },
  setNoArrivalLoadsController(state, controller) {
    state.no_arrival_loads_controller = controller;
  },
  setNoArrivalLoadsPagination(state, headers) {
    state.no_arrival_loads_pagination = {
      currentPage: Number(headers.currentpage),
      totalPages: Number(headers.totalpages),
      totalRecords: Number(headers.totalitems),
    };
  },
  setNoArrivalLoadsLoading(state, bool) {
    state.no_arrival_loads_loading = bool;
  },
  setNoArrivalLoads(state, loads) {
    state.no_arrival_loads = loads;
  },
  setNoArrivalLoadsQuery(state, query) {
    state.no_arrival_loads_query = query;
  },
  setNoDepartureLoadsController(state, controller) {
    state.no_departure_loads_controller = controller;
  },
  setNoDepartureLoadsPagination(state, headers) {
    state.no_departure_loads_pagination = {
      currentPage: Number(headers.currentpage),
      totalPages: Number(headers.totalpages),
      totalRecords: Number(headers.totalitems),
    };
  },
  setNoDepartureLoadsLoading(state, bool) {
    state.no_departure_loads_loading = bool;
  },
  setNoDepartureLoads(state, loads) {
    state.no_departure_loads = loads;
  },
  setNoDepartureLoadsQuery(state, query) {
    state.no_departure_loads_query = query;
  },
  setNoPickupLoadsController(state, controller) {
    state.no_pickup_loads_controller = controller;
  },
  setNoPickupLoadsPagination(state, headers) {
    state.no_pickup_loads_pagination = {
      currentPage: Number(headers.currentpage),
      totalPages: Number(headers.totalpages),
      totalRecords: Number(headers.totalitems),
    };
  },
  setNoPickupLoadsLoading(state, bool) {
    state.no_pickup_loads_loading = bool;
  },
  setNoPickupLoads(state, loads) {
    state.no_pickup_loads = loads;
  },
  setNoPickupLoadsQuery(state, query) {
    state.no_pickup_loads_query = query;
  },
  setNoDeliveryLoadsController(state, controller) {
    state.no_delivery_loads_controller = controller;
  },
  setNoDeliveryLoadsPagination(state, headers) {
    state.no_delivery_loads_pagination = {
      currentPage: Number(headers.currentpage),
      totalPages: Number(headers.totalpages),
      totalRecords: Number(headers.totalitems),
    };
  },
  setNoDeliveryLoadsLoading(state, bool) {
    state.no_delivery_loads_loading = bool;
  },
  setNoDeliveryLoads(state, loads) {
    state.no_delivery_loads = loads;
  },
  setNoDeliveryLoadsQuery(state, query) {
    state.no_delivery_loads_query = query;
  },
  setNoEldLoadsController(state, controller) {
    state.no_eld_loads_controller = controller;
  },
  setNoEldLoadsPagination(state, headers) {
    state.no_eld_loads_pagination = {
      currentPage: Number(headers.currentpage),
      totalPages: Number(headers.totalpages),
      totalRecords: Number(headers.totalitems),
    };
  },
  setNoEldLoadsLoading(state, bool) {
    state.no_eld_loads_loading = bool;
  },
  setNoEldLoads(state, loads) {
    state.no_eld_loads = loads;
  },
  setNoEldLoadsQuery(state, query) {
    state.no_eld_loads_query = query;
  },
  setAssignedVehicleLoadsController(state, controller) {
    state.assigned_vehicle_loads_controller = controller;
  },
  setAssignedVehicleLoadsPagination(state, headers) {
    state.assigned_vehicle_loads_pagination = {
      currentPage: Number(headers.currentpage),
      totalPages: Number(headers.totalpages),
      totalRecords: Number(headers.totalitems),
    };
  },
  setAssignedVehicleLoadsLoading(state, bool) {
    state.assigned_vehicle_loads_loading = bool;
  },
  setAssignedVehicleLoads(state, loads) {
    state.assigned_vehicle_loads = loads;
  },
  setNoAssignedVehicleLoadsController(state, controller) {
    state.no_assigned_vehicle_loads_controller = controller;
  },
  setNoAssignedVehicleLoadsPagination(state, headers) {
    state.no_assigned_vehicle_loads_pagination = {
      currentPage: Number(headers.currentpage),
      totalPages: Number(headers.totalpages),
      totalRecords: Number(headers.totalitems),
    };
  },
  setNoAssignedVehicleLoadsLoading(state, bool) {
    state.no_assigned_vehicle_loads_loading = bool;
  },
  setNoAssignedVehicleLoads(state, loads) {
    state.no_assigned_vehicle_loads = loads;
  },
  setNoAssignedVehicleLoadsQuery(state, query) {
    state.no_assigned_vehicle_loads_query = query;
  },
  setPendingTrackingLoadsController(state, controller) {
    state.pending_tracking_loads_controller = controller;
  },
  setPendingTrackingLoadsPagination(state, headers) {
    state.pending_tracking_loads_pagination = {
      currentPage: Number(headers.currentpage),
      totalPages: Number(headers.totalpages),
      totalRecords: Number(headers.totalitems),
    };
  },
  setPendingTrackingLoadsLoading(state, bool) {
    state.pending_tracking_loads_loading = bool;
  },
  setPendingTrackingLoads(state, loads) {
    state.pending_tracking_loads = loads;
  },
  setPendingTrackingLoadsQuery(state, query) {
    state.pending_tracking_loads_query = query;
  },
  setNotTrackingLoadsController(state, controller) {
    state.not_tracking_loads_controller = controller;
  },
  setNotTrackingLoadsPagination(state, headers) {
    state.not_tracking_loads_pagination = {
      currentPage: Number(headers.currentpage),
      totalPages: Number(headers.totalpages),
      totalRecords: Number(headers.totalitems),
    };
  },
  setNotTrackingLoadsLoading(state, bool) {
    state.not_tracking_loads_loading = bool;
  },
  setNotTrackingLoads(state, loads) {
    state.not_tracking_loads = loads;
  },
  setNotTrackingLoadsQuery(state, query) {
    state.not_tracking_loads_query = query;
  },
  setDestinationRouteLoading(state, bool) {
    state.load_route_loading = bool;
  },
  setDestinationRoute(state, route) {
    state.destination_route = route;
  },
  setLoadRouteLoading(state, bool) {
    state.load_route_loading = bool;
  },
  setLoadRouteDistanceLoading(state, bool) {
    state.load_route_distance_loading = bool;
  },
  setLoadRouteDistance(state, distance) {
    state.load_route_distance = distance;
  },
  setLoadLogs(state, data) {
    state.load_logs = data;
  },
  setHasLoadLogsLoaded(state, bool) {
    state.has_load_logs_loaded = bool;
  },
  setAlertVehicles(state, data) {
    state.alert_vehicles = data;
  },
  setHasAlertVehiclesLoaded(state, bool) {
    state.has_alert_vehicles_loaded = bool;
  },
  setManuallyAddedVehicles(state, data) {
    state.manually_added_vehicles = data;
  },
  setManuallyAddedVehiclesLoaded(state, bool) {
    state.manually_added_vehicles_loaded = bool;
  },
  setStopLoadLogs(state, data) {
    state.stop_load_logs = data;
  },
  setHasStopLoadLogsLoaded(state, bool) {
    state.has_stop_load_logs_loaded = bool;
  },
  setLoadRoute(state, route) {
    state.load_route = route;
  },
  addTruckRoute(state, { route, carrierVehicleId, section }) {
    if (Object.keys(state.truck_routes).includes(carrierVehicleId)) {
      state.truck_routes[carrierVehicleId] = {
        ...state.truck_routes[carrierVehicleId],
        [section]: route,
      };
    } else {
      state.truck_routes[carrierVehicleId] = { [section]: route };
    }
  },
  setTruckRouteLoading(state, bool) {
    state.truck_route_loading = bool;
  },
  setUseMonitorRoutes(state, bool) {
    state.use_monitor_routes = bool;
  },
  setVehicles(state, vehicles) {
    state.vehicles = vehicles;
  },
  setHasVehiclesLoaded(state, bool) {
    state.has_vehicles_loaded = bool;
  },
  setHasNearByVehiclesLoaded(state, bool) {
    state.has_near_by_vehicles_loaded = bool;
  },
  setNearByVehicles(state, data) {
    state.near_by_vehicles = data;
  },
  setHasDebugVehiclesLoaded(state, bool) {
    state.has_debug_vehicles_loaded = bool;
  },
  setDebugVehicles(state, data) {
    state.debug_vehicles = data;
  },
  setHasAssignedVehicleLoaded(state, bool) {
    state.has_assigned_vehicle_loaded = bool;
  },
  setAssignedVehicle(state, data) {
    state.assigned_vehicle = data;
  },
  setHasTruckTraceDataLoaded(state, bool) {
    state.has_truck_trace_data_loaded = bool;
  },
  setTruckTraceData(state, data) {
    state.truck_trace_data = data;
  },
  setCarrierELDTouches(state, eldTouches) {
    state.carrier_eld_touches = eldTouches;
  },
  setHasCarrierELDTouchesLoaded(state, bool) {
    state.has_carrier_eld_touches_loaded = bool;
  },
  setHasCalledLoadIndex(state, bool) {
    state.has_called_load_index = bool;
  },
  incrementMovementsShowCount(state) {
    state.movements_show_count++;
  },
  setLoad(state, load) {
    state.load = load;
  },
  setLoadLoading(state, bool) {
    state.load_loading = bool;
  },
  setOpenLoadsController(state, controller) {
    state.open_loads_controller = controller;
  },

  setOpenLoadsLoading(state, bool) {
    state.open_loads_loading = bool;
  },
  setOpenLoads(state, loads) {
    state.open_loads = loads;
  },
  setOpenLoadsPagination(state, headers) {
    state.open_loads_pagination = {
      currentPage: Number(headers.currentpage),
      totalPages: Number(headers.totalpages),
      totalRecords: Number(headers.totalitems),
    };
  },
  setOpenLoadsQuery(state, query) {
    state.open_loads_query = query;
  },
  setClosedLoadsLoading(state, bool) {
    state.closed_loads_loading = bool;
  },
  setClosedLoads(state, loads) {
    state.closed_loads = loads;
  },
  setClosedLoadsController(state, controller) {
    state.closed_loads_controller = controller;
  },
  setClosedLoadsPagination(state, headers) {
    state.closed_loads_pagination = {
      currentPage: Number(headers.currentpage),
      totalPages: Number(headers.totalpages),
      totalRecords: Number(headers.totalitems),
    };
  },
  setClosedLoadsQuery(state, query) {
    state.closed_loads_query = query;
  },
  setResultLoadsController(state, controller) {
    state.result_loads_controller = controller;
  },
  setResultLoadsLoading(state, bool) {
    state.result_loads_loading = bool;
  },
  setResultLoads(state, loads) {
    state.result_loads = loads;
  },
  setResultLoadsPagination(state, headers) {
    state.result_loads_pagination = {
      currentPage: Number(headers.currentpage),
      totalPages: Number(headers.totalpages),
      totalRecords: Number(headers.totalitems),
    };
  },
  setOpenMovementTicketsLoading(state, bool) {
    state.open_alerts_loading = bool;
  },
  setOpenMovementTicketsController(state, controller) {
    state.open_alerts_controller = controller;
  },
  setOpenMovementTickets(state, tickets) {
    state.open_alerts = tickets;
  },
  setOpenMovementTicketsPagination(state, headers) {
    state.open_alerts_pagination = {
      currentPage: Number(headers.currentpage) || 1,
      totalPages: Number(headers.totalpages) || 1,
      totalRecords: Number(headers.totalitems) || 0,
    };
  },
  setOpenMovementTicketsQuery(state, query) {
    state.open_alerts_query = query;
  },
  setClosedMovementTicketsController(state, controller) {
    state.closed_movement_tickets_controller = controller;
  },
  setClosedMovementTicketsLoading(state, bool) {
    state.closed_alerts_loading = bool;
  },
  setClosedMovementTickets(state, tickets) {
    state.closed_alerts = tickets;
  },
  setClosedMovementTicketsPagination(state, headers) {
    state.closed_alerts_pagination = {
      currentPage: Number(headers.currentpage) || 1,
      totalPages: Number(headers.totalpages) || 1,
      totalRecords: Number(headers.totalitems) || 0,
    };
  },
  setClosedMovementTicketsQuery(state, query) {
    state.closed_alerts_query = query;
  },
  setPendingAlertsLoading(state, bool) {
    state.pending_alerts_loading = bool;
  },
  setPendingAlertsController(state, controller) {
    state.pending_alerts_controller = controller;
  },
  setPendingAlerts(state, tickets) {
    state.pending_alerts = tickets;
  },
  setPendingAlertsPagination(state, headers) {
    state.pending_alerts_pagination = {
      currentPage: Number(headers.currentpage) || 1,
      totalPages: Number(headers.totalpages) || 1,
      totalRecords: Number(headers.totalitems) || 0,
    };
  },
  setPendingAlertsQuery(state, query) {
    state.pending_alerts_query = query;
  },
  setRecommendedAlertsLoading(state, bool) {
    state.recommended_alerts_loading = bool;
  },
  setRecommendedAlertsController(state, controller) {
    state.recommended_alerts_controller = controller;
  },
  setRecommendedAlerts(state, tickets) {
    state.recommended_alerts = tickets;
  },
  setRecommendedAlertsPagination(state, headers) {
    state.recommended_alerts_pagination = {
      currentPage: Number(headers.currentpage) || 1,
      totalPages: Number(headers.totalpages) || 1,
      totalRecords: Number(headers.totalitems) || 0,
    };
  },
  setRecommendedAlertsQuery(state, query) {
    state.recommended_alerts_query = query;
  },
  setOpenRateConTicketsPagination(state, headers) {
    state.open_rate_con_tickets_pagination = {
      currentPage: Number(headers.currentpage),
      totalPages: Number(headers.totalpages),
      totalRecords: Number(headers.totalitems),
    };
  },
  setClosedMovementsDashboard(state, res) {
    if (!res) {
      state.load_lock_events_closed = [];
      // state.movements = [];
      // state.rate_confirmations = [];
      state.load_lock_events_closed_pagination = {
        totalRecords: 0,
        totalPages: 0,
        currentPage: 1,
      };
      return;
    }
    const headers = res?.headers;
    state.load_lock_events_closed_pagination = {
      currentPage: Number(headers.currentpage),
      totalPages: Number(headers.totalpages),
      totalRecords: Number(headers.totalitems),
    };
    state.load_lock_events_closed = res?.data?.load_lock_events;
    // const movements = res?.data?.load_lock_events?.flatMap(
    //   (load_lock_event) => load_lock_event.movement
    // );
    // state.movements = movements;
    // const rate_cons = res?.data?.load_lock_events?.flatMap(
    //   (load_lock_event) => load_lock_event.rate_confirmation
    // );
    // state.rate_confirmations = rate_cons;
  },
  setLoadsShow(state, ev) {
    if (ev?.movement) {
      state.movements = [ev.movement];
    }
    if (ev) {
      state.ticket_show = ev;
    }
  },
  incrementAlertTableVersion(state) {
    if (state.alert_table_version + 1 > state.alert_table_max) {
      state.alert_table_version = 1;
    } else {
      state.alert_table_version++;
    }
  },
  setUserTicketRole(state, role) {
    state.user_ticket_role = role;
  },
  setLoadLockAssignees(state, { data: data, user: user }) {
    let userData = null;
    if (Array.isArray(data) && data?.length > 0) {
      userData = data?.find((assignee) => {
        assignee?.id == user.id;
      });
      if (!userData) {
        data.push({
          id: user.id,
          full_name: `${user.first_name} ${user.last_name}`,
          email: user?.email,
          phone_e164: user?.phone_e164,
          is_self_staff:
            user?.scopes?.includes('tickets_load_lock_staff') &&
            !user?.scopes?.includes('tickets_load_lock_manager'),
        });
      }
      state.load_lock_assignees = data;
    } else {
      if (!userData) {
        data.push({
          id: user.id,
          full_name: `${user.first_name} ${user.last_name}`,
          email: user?.email,
          phone_e164: user?.phone_e164,
          is_self_staff:
            user?.scopes?.includes('tickets_load_lock_staff') &&
            !user?.scopes?.includes('tickets_load_lock_manager'),
        });
        state.load_lock_assignees = data;
      } else {
        state.load_lock_assignees = [];
      }
    }
  },
  updateMovementTicket(state, data) {
    let index = state.movements?.[0]?.tickets?.findIndex(
      (t) => t?.id === data?.id
    );
    if (index > -1) {
      state.movements[0].tickets[index] = data;
    }
  },
  setEventShowFromShow(state, { data, movement, carrier }) {
    let items = data
      .filter((event) => event?.ticket?.id > 0)
      .sort((a, b) => {
        return b.ticket.id - a.ticket.id;
      });
    if (items?.[0]) {
      let mvmt = {
        id: movement?.id,
        carrier_vehicle_id: movement?.carrier_vehicle_id,
      };
      items[0]['movement'] = mvmt;
      items[0]['carrier'] = carrier;
      state.event_show = items[0];
    }
  },
  setTraceDataLoadId(state, id) {
    state.trace_data_load_id = id;
  },
  setRecentByCVLoadId(state, id) {
    state.recent_by_cv_load_id = id;
  },
  setLoadLocalStorageSearchResults(state, { type, data, pagination }) {
    const localSearchStorage = loadsLocalStorage[type];
    localStorage.setItem(
      localSearchStorage.storageResults,
      JSON.stringify(data)
    );
    localStorage.setItem(
      localSearchStorage.storagePagination,
      JSON.stringify(pagination)
    );
  },
  setAlertCount(state, data) {
    state.alert_count = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
